import { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { isStepCompleted } from "features/ecommerce/helpers";
import When from "ui/support/When";
import type { OnboardingInputControlProps } from "./types";

const OnboardingInputControl = ({
    sx,
    name,
    isIncomplete,
    renderInput,
    requestedChangeFields
}: OnboardingInputControlProps) => {
    const getFieldRequestedChanges = (name: string) => {
        if (requestedChangeFields instanceof Object) {
            return requestedChangeFields[name];
        }

        return null;
    };

    const getDisabled = () => {
        if (getFieldRequestedChanges(name)) {
            return false;
        }

        if (isStepCompleted(isIncomplete)) {
            return true;
        }

        return false;
    };

    return (
        <Box
            sx={{
                width: '100%',
                ...sx
            }}
        >
            {renderInput({
                disabled: getDisabled()
            })}
            <When
                if={Boolean(getFieldRequestedChanges(name))}
                then={() => (
                    <Typography
                        gutterBottom
                        variant='caption'
                        color='error.main'
                    >
                        {getFieldRequestedChanges(name)?.comments}
                    </Typography>
                )}
            />
        </Box>
    );
};

export default memo(OnboardingInputControl);
